module.exports = __webpack_public_path__ + "static/media/checkmark-white.8b4feae3.svg";